/** Rewrite worker asset URLs so phone/LAN preview uses the current page host. */
export function assetSrc(url: string | null | undefined): string {
  if (!url) return ''
  if (typeof window === 'undefined') return url

  try {
    const parsed = new URL(url, window.location.origin)

    if (!import.meta.env.DEV) {
      // Production: route workers.dev asset URLs through the same-origin
      // Pages Function proxy (functions/assets/[[path]].ts).
      if (
        parsed.hostname.endsWith('.workers.dev') &&
        parsed.pathname.startsWith('/assets/')
      ) {
        return `${window.location.origin}${parsed.pathname}${parsed.search}`
      }
      return url
    }

    const privateHost =
      /^(localhost|127\.0\.0\.1|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|172\.(?:1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/
    if (parsed.pathname.startsWith('/assets/') && privateHost.test(parsed.hostname)) {
      return `${window.location.origin}${parsed.pathname}${parsed.search}`
    }
  } catch {
    return url
  }

  return url
}
